import React from 'react';

const GradientStrip = ({ height }) => (
  <div
    className="flex flex-row h-12 shrink-0"
    style={height ? { height } : undefined}
    aria-hidden="true">
    <div
      className="w-full h-full"
      style={{ background: 'linear-gradient(90deg, #4EB6AF 0%, #4F4898 100%)' }}
    />
  </div>
);

export default GradientStrip;
